import React, { FC, MouseEvent } from "react";
import { LinkButton, Typography, Row, Column, Image, Button } from "../..";

import { GiftIcon, PositiveBulletIcon } from "../../../icons";

export interface ILoyaltyBanner {
  content: { id: number; text: string }[];
  labels?: {
    title?: string;
    submitButtonLabel?: string;
    memberBenefits: string;
  };
  onSubmitBttn?: (e: MouseEvent) => void;
  showMember?: boolean;
  imgUrl?: string;
  customImage?: JSX.Element;
}

const LoyaltyBanner: FC<ILoyaltyBanner> = ({
  labels = {
    title: "Join Discount Program",
    submitButtonLabel: "Join Now",
    memberBenefits: "Member Benefits",
  },
  content,
  onSubmitBttn,
  showMember = true,
  imgUrl,
  customImage,
}) => {
  const { title, submitButtonLabel, memberBenefits } = labels;

  return (
    <>
      <Row>
        <Column xs={12} lg={4} classes={{ root: "order-lg-last ps-lg-0" }}>
          <div className="d-flex justify-content-center align-items-center h-100 border-widget py-9 py-lg-0">
            {customImage || <Image src={imgUrl} alt="" />}
          </div>
        </Column>
        <Column xs={12} lg={8} classes={{ root: "pe-lg-0" }}>
          <div className="p-6 p-md-7 bg-color-blue text-color-white">
            <Typography
              data-testid="LoyaltyBanner__title"
              variant="h3-enriched"
              as="div"
              classes={{ root: "mb-6" }}
            >
              {title}
            </Typography>
            <ul
              data-testid="LoyaltyBanner__content"
              className="list-unstyled p-0 m-0 mb-7"
            >
              {content?.map((item) => {
                return (
                  <li
                    className="d-flex align-items-center p-banner mb-4 mb-md-0"
                    key={item.id}
                  >
                    <Typography variant="p-banner">
                      <PositiveBulletIcon
                        width={16}
                        height={16}
                        className="me-4"
                      />
                      {item.text}
                    </Typography>
                  </li>
                );
              })}
            </ul>
            <Button
              data-testid="LoyaltyBanner__submit"
              variant="secondary"
              onClick={onSubmitBttn}
            >
              {submitButtonLabel}
            </Button>
          </div>
        </Column>
      </Row>

      {showMember && (
        <div
          data-testid="LoyaltyBanner__benefits"
          className="mt-4 d-flex justify-content-start"
        >
          <GiftIcon />
          <LinkButton classes={{ root: "ms-3" }}>{memberBenefits}</LinkButton>
        </div>
      )}
    </>
  );
};

export default LoyaltyBanner;
